import React from 'react';
import { isDOC, isPDF, isPRES, isImage, isSPREADSHEET, isVideo } from './FileTypeHelpers';
import {
	FileImage,
	FileLink,
	FileOther,
	FilePDF,
	FileSlides,
	FileSpreadsheet,
	FileText,
	FileVideo,
} from '../components/Icons';

const FileIcon = ({ type, favicon, contentType, ext, size }) => {
	let imgSize = 24;
	if (size) {
		imgSize = size;
	}

	if (type === 'FILE') {
		if (isPDF(contentType)) return <FilePDF size={imgSize} />;
		else if (isDOC(contentType, ext)) return <FileText size={imgSize} />;
		else if (isPRES(contentType, ext)) return <FileSlides size={imgSize} />;
		else if (isImage(contentType)) return <FileImage size={imgSize} />;
		else if (isSPREADSHEET(contentType, ext)) return <FileSpreadsheet size={imgSize} />;
		else if (isVideo(contentType, ext)) return <FileVideo size={imgSize} />;
		else return <FileOther size={imgSize} />;
	} else {
		if (favicon) {
			return <img alt={favicon} src={favicon} />;
		}
		return <FileLink size={imgSize} />;
	}
};

export default FileIcon;
